// Clavier de l'iPhone (surtout l'app ajoutée à l'écran d'accueil) : quand le champ qui a la main
// disparaît (écran redessiné, fiche fermée), iOS ferme le clavier sans recaler la page. La barre du
// bas et les boutons flottants restent alors à la hauteur de l'ancien clavier, au milieu de l'écran.
//  1. on rend la main avant de retirer un champ (mount, fermeture d'une fiche) ;
//  2. filet sur iOS : clavier refermé → la page est recalée d'un pixel aller-retour (invisible).
const TEXT_FIELD = 'input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit])'
  + ':not([type=reset]):not([type=file]):not([type=range]):not([type=color]), textarea, select, [contenteditable]:not([contenteditable=false])';

const typing = (): boolean => {
  const a = document.activeElement;
  return !!a && a !== document.body && a.matches(TEXT_FIELD);
};

/** Rend la main si le champ actif est dans `root` : à appeler juste avant de retirer `root` ou son contenu. */
export function releaseFocusIn(root: ParentNode): void {
  const a = document.activeElement as HTMLElement | null;
  if (a && a !== document.body && root.contains(a) && a.matches(TEXT_FIELD)) a.blur();
}

const isIOS = (): boolean => /iP(hone|ad|od)/.test(navigator.userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

/** Filet de sécurité, une fois au démarrage : recale la page quand le clavier de l'iPhone se referme. */
export function keepViewportAfterKeyboard(): void {
  const vv = window.visualViewport;
  if (!vv || !isIOS()) return;
  let timer = 0;
  const realign = (delay: number) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      if (typing() || Math.abs(vv.scale - 1) > 0.01) return;   // encore au clavier, ou zoom voulu
      const x = window.scrollX, y = window.scrollY;
      window.scrollTo(x, y > 0 ? y - 1 : y + 1);
      requestAnimationFrame(() => window.scrollTo(x, y));
    }, delay);
  };
  let lastH = vv.height;
  vv.addEventListener('resize', () => { if (vv.height > lastH + 80) realign(60); lastH = vv.height; });
  document.addEventListener('focusout', e => { if ((e.target as Element | null)?.matches?.(TEXT_FIELD)) realign(350); });
}
